import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
	sectionContainer: {
		marginTop: '5rem',
		maxHeight: '60rem',
		overflow: 'auto',
		border: '0.1rem solid rgba(0, 0, 0, 0.38)',
		borderRadius: '0.4rem',
		padding: '1rem 2.3rem 1rem 2.3rem'
	},
	logContainer: {
		backgroundColor: '#f3f4f6',
		border: '0.1rem solid rgba(0, 0, 0, 0.38)',
		padding: '1rem',
		marginTop: '1.8rem',
		borderRadius: '0.4rem'
	},
	changeType: {
		color: '#fc4b58',
		fontWeight: 'bolder',
		textTransform: 'capitalize'
	},
	changeKeysContainer: {
		border: '0.1rem solid rgba(0, 0, 0, 0.38)',
		padding: '0.5rem',
		borderRadius: '0.4rem',
		maxWidth: '50rem',
		width: 'auto',
		overflow: 'hidden',
		wordWrap: 'break-word'
	},
	paginationContainer: {
		display: 'flex',
		justifyContent: 'center',
		marginTop: '2rem'
	}
}));
